import { components, MultiValueGenericProps, GroupBase } from 'react-select'

const MultiValueLabel = (
	props: MultiValueGenericProps<any, true, GroupBase<any>>
) => (
	<components.MultiValueLabel {...props}>
		<span
			data-tip={props.data.label}
			style={{
				backgroundColor: props.data.color,
				color: '#000', // Adjust for better contrast
				borderRadius: '12px',
				padding: '4px 8px',
				fontSize: '12px'
			}}
		>
			{props.data.label}
		</span>
	</components.MultiValueLabel>
)

export default MultiValueLabel
